<template>
  <div ref="body">
    <template v-if="!loading">
      <slot ref="body"></slot>
    </template>
  </div>

</template>
<script>
import Layer0 from '../../extend_classes/Layer0'
export default {
  name: "aux",
  extends: Layer0,
  data: function () {
    return {
      ap: [],
      fields: {},
      fields2: {}
    }
  },
  props: {
    onlyCurrentAccount: {
      default: false,
      required: false,
      type: Boolean
    },
    accountProperties: {
      default: '[]',
      required: false,
      type: String
    },
    accountId: {
      type: Number,
      required: false
    },
    treeId: {
        required: false,
        default: '',
        type: String
    },
    treeIdLast: {
        required: false,
        default: '',
        type: String
    },
    numberPeriodsBack: {
      required: false,
      type: String
    },
    numberPeriods: {
      required: false,
      type: String,
      default: ''
    },
    callback: {
      type: String,
      required: false
    }
  },
  methods: {
    getAp() {
      let at;
      try {
        at = JSON.parse(this.accountProperties);
        if (!Array.isArray(at))
          at = [];
      }
      catch (e) {
        at = [];
      }
      if (at.length)
        this.ap = at;
    },
    async getInfo() {
      this.loading           = true;
      this.aid               = this.accountId;
      let createdAt          = null;
      let countryId          = null;
      let profile            = [];
      this.fields['old']     = {}
      this.fields['oldLast'] = {}

      if (!this.aid)
        this.aid = await this.store.dispatch('getAccountId');
      if (!this.aid)
        return false;
      if (this.onlyCurrentAccount) {
        this.fields['current'] = this.store.state.currentAccount;
        
        if (this.callback && window[this.callback] && (typeof window[this.callback]==='function'))
          window[this.callback](this.fields);
        this.loading = false;

        return false
      }

      let propsQueryProfile = []
      let propsQueryPosition = ''

      this.ap.map(item => {
        let itemArr = item.split('.')
        if(itemArr[1]) {

          if (itemArr[0] == 'p') {
            propsQueryProfile.push(itemArr[1])
          } else if (itemArr[0] == 'm') {
            propsQueryPosition += `properties[]=${itemArr[1]}&`
          } else {
            propsQueryProfile.push(itemArr[1])
          }

        } else {
          propsQueryProfile.push(itemArr[1])
        }
      });

      await this.store.dispatch('requestApi3', {
        path: `account/${this.aid}/profile`,
        method: 'get',
      }).then(response => {

        response?.data?.payload.forEach((fromP) => {
          let found = propsQueryProfile.find((p) => p == fromP.alias)
          if (found) {
            profile.push(fromP)
            this.fields['old']['p.' + fromP.alias] = {
              label            : fromP.title,
              presentableValue : fromP.value.presentable,
              rawValue         : fromP.value.raw,
              value            : fromP.value.raw
            }
          }
        })

        createdAt = response?.data?.payload.find((f) => f.alias === "created_at")
        countryId = response?.data?.payload.find((f) => f.alias === "country_id")
        if(!createdAt) {
          throw 'profile -> created_at is not found'
        }

        if(!countryId) {
          throw 'profile -> countryId is not found'
        }
      }).catch((e) => {
        console.log('profile error: ',e)
      });

      this.fields['current'] = this.store.state.currentAccount

      if (this.numberPeriodsBack) {
        if (this.treeIdLast != '' && this.treeIdLast != 'all') {
          propsQueryPosition += `treeId=${this.treeIdLast}&`
        }

        console.log('----------------111---------------');
        await this.store.dispatch('requestApi3', {
          path: `account/${this.aid}/position?${propsQueryPosition}numberPeriodsBack=${this.numberPeriodsBack}`,
          method: 'get'
        }).then(response => {

          if (response?.data?.payload.length) {
            this.fields['propertiesLast'] = []

            for (let tree of response?.data?.payload) {
              tree.properties.forEach((item) => {
                this.fields['oldLast']['m.' + item.alias] = {
                  label            : item.title,
                  presentableValue : item.value.presentable,
                  rawValue         : item.value.raw,
                  value            : item.value.raw
                }
              })

            this.fields.propertiesLast = this.fields.propertiesLast.concat(tree.properties)
            this.fields['positionLast' + tree.treeId] = {} 

            Object.keys(tree).forEach((f) => {
              if (f != 'properties') {
                this.fields['positionLast' + tree.treeId][f] = tree[f]
              }
            })

            if (this.treeIdLast != 'all') break;
          }

          } else {
            console.log(`account/${this.aid}/position?${propsQueryPosition}numberPeriodsBack=${this.numberPeriodsBack} - payload[]`)
          }

        })
      }

      if (this.treeId != '' && this.treeId != 'all') {
        propsQueryPosition += `treeId=${this.treeId}&`
      }

      const queryPeriod = this.numberPeriods == '' ? '' : `${propsQueryPosition ? '&' : '?'}numberPeriodsBack=${this.numberPeriods}`

      await this.store.dispatch('requestApi3', {
        path: `account/${this.aid}/position?${propsQueryPosition}${queryPeriod}`,
        method: 'get'
      }).then(response => {

        if (response?.data?.payload.length) {
          this.fields['properties'] = [].concat(profile);

          for (let tree of response?.data?.payload) {
            tree.properties.forEach((item) => {
              this.fields['old']['m.' + item.alias] = {
                label            : item.title,
                presentableValue : item.value.presentable,
                rawValue         : item.value.raw,
                value            : item.value.raw
              }
            })

            this.fields.properties = this.fields.properties.concat(tree.properties);
            this.fields['position' + tree.treeId] = {} 

            Object.keys(tree).forEach((f) => {
              if (f != 'properties') {
                this.fields['position' + tree.treeId][f] = tree[f]
              }
            })

            if (this.treeId != 'all') break;
          }

        } else {
          console.log(`account/${this.aid}/position?${propsQueryPosition} - payload[]`)
        }

        if (createdAt) {
          this.fields.properties.push(createdAt)
        }

        if (countryId) {
          this.fields.properties.push(countryId)
        }

        this.store.dispatch('requestApi3', {
          path: `account/${this.aid}/wallet`,
          method: 'get'
        }).then(res => {

          this.fields['wallet'] = res?.data?.payload;

          if (this.callback && window[this.callback] && (typeof window[this.callback]==='function'))
            window[this.callback](this.fields);
          this.loading = false;

        }).catch((e) => {
          console.log(e)
        })
      }).catch((e) => {
        console.log(e)
      })

    }
  }
}
</script>
<style scoped>
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap/dist/css/bootstrap-grid.min.css';
</style>